var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.topic && !!_vm.topic.id)?_c('default-button',_vm._g({staticClass:"btn-alert",attrs:{"color":!!_vm.topic.upcoming_alert_count ? 'primary' : 'regular'}},_vm.$listeners),[_c('open-icon',{attrs:{"glyph":"bell"}}),_vm._v(" "+_vm._s(_vm._f("nibnut.number")(_vm.topic.upcoming_alert_count,"0,0"))+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }